<mat-nav-list>
  <mat-toolbar class="toolbar-logged">
    <mat-toolbar-row>
      <span class="person-details">
        <mat-icon>person</mat-icon> {{ accountInfo.firstName }}
        {{ accountInfo.lastName }}
      </span>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-divider></mat-divider>

  <div class="menu-panel">
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard">
      <mat-icon #icon1>trending_up</mat-icon>
      {{ "statistic-menu-item" | translate }}
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/municipalities">
      <mat-icon #icon2>group_work</mat-icon>
      {{ "municipality-menu-item" | translate }}
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/buildings">
      <mat-icon>apartment</mat-icon> {{ "buildings-menu-item" | translate }}
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/periods">
      <mat-icon>timeline</mat-icon> {{ "periods-menu-item" | translate }}
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/buildings-map">
      <mat-icon>map</mat-icon> {{ "building-map-menu-item" | translate }}
    </a>
    <a *ngIf="isAdministrator" mat-list-item routerLinkActive="list-item-active" routerLink="/management">
      <mat-icon>settings</mat-icon>
      {{ "management-map-menu-item" | translate }}
    </a>
  </div>

  <!-- <div class="logo-images">
    <img src="/assets/logo/logo-full-2.jpg" />
    <img src="/assets/logo/usaid-logo.png" />
  </div> -->
</mat-nav-list>